// extracted by mini-css-extract-plugin
export default {"recos":"R3-z","productCardOverride":"S3-z","rowHasBadge":"T3-z"};